import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// Remove SEO prerender block once React hydrates
const seoBlock = document.getElementById("seo-prerender");
if (seoBlock) seoBlock.remove();

createRoot(document.getElementById("root")!).render(<App />);
